import { render, staticRenderFns } from "./musicManage.vue?vue&type=template&id=f988ae88&"
import script from "./musicManage.vue?vue&type=script&lang=js&"
export * from "./musicManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f988ae88')) {
      api.createRecord('f988ae88', component.options)
    } else {
      api.reload('f988ae88', component.options)
    }
    module.hot.accept("./musicManage.vue?vue&type=template&id=f988ae88&", function () {
      api.rerender('f988ae88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/joypal/musicManage.vue"
export default component.exports